import HttpService from "../baseHttp";


// 销售员 列表，单条查看/编辑
export const HttpGetSalesmanList = (data = {}, config) => HttpService.get('/api/v2/Salesperson/findByPage', { params: data })

export const HttpGetSalesmanOne = (data = {}, config) => HttpService.get('/api/v2/Salesperson/getById', { params: data })
export const HttpSaveSalesmanOne = (data = {}, config) => HttpService.post('/api/v2/Salesperson/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 停用
export const HttpCancelSalesmanOne = (data = {}, config) => HttpService.get('/api/v2/Salesperson/cancel', { params: data })
// 激活
export const HttpActiveSalesmanOne = (data = {}, config) => HttpService.get('/api/v2/Salesperson/active', { params: data })

//客户 列表，单条查看/编辑 
export const HttpGetCustomerList = (data = {}, config) => HttpService.get('/api/v2/Customer/findByPage', { params: data })

export const HttpGetCustomerOne = (data = {}, config) => HttpService.get('/api/v2/Customer/getById', { params: data })

export const HttpSaveCustomerOne = (data = {}, config) => HttpService.post('/api/v2/Customer/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 停用
export const HttpCancelCustomerOne = (data = {}, config) => HttpService.get('/api/v2/Customer/cancel', { params: data })
// 激活
export const HttpActiveCustomerOne = (data = {}, config) => HttpService.get('/api/v2/Customer/active', { params: data })

// 获取用户地址列表
export const HttpGetCustomerAddress = (data = {}, config) => HttpService.get('/api/v2/Customer/findByCustomerId', { params: data })

// 获取全部销售员，全部客户下拉列表
export const HttpGetAllSalesmanList = (data = {}, config) => HttpService.get('/api/v2/Salesperson/findAll', { params: data })

export const HttpGetAllCustomerList = (data = {}, config) => HttpService.get('/api/v2/Customer/findAll', { params: data })








